module.exports = __webpack_public_path__ + "static/media/bookmark-inactive.0c03b0ff.svg";